import { render, staticRenderFns } from "./SupportDialog.vue?vue&type=template&id=14d28837&scoped=true"
import script from "./SupportDialog.vue?vue&type=script&lang=js"
export * from "./SupportDialog.vue?vue&type=script&lang=js"
import style0 from "./SupportDialog.vue?vue&type=style&index=0&id=14d28837&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d28837",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14d28837')) {
      api.createRecord('14d28837', component.options)
    } else {
      api.reload('14d28837', component.options)
    }
    module.hot.accept("./SupportDialog.vue?vue&type=template&id=14d28837&scoped=true", function () {
      api.rerender('14d28837', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/SupportDialog.vue"
export default component.exports